import React, { ReactNode, useEffect } from "react";

import {
  extendVariants,
  ModalContent,
  ModalProps,
  Modal as NextModal,
} from "@nextui-org/react";

import { TColor } from "@/ui/CloseButton";
import type { Viewport } from "next";

export const viewport: Viewport = {
  width: "device-width",
  initialScale: 1,
  viewportFit: "cover",
  interactiveWidget: "overlays-content",
};

/**
 * !IN PROGRESS DON'T USE
 * This is a modal component that can be used to display content in a modal dialog.
 */

const CustomModal = extendVariants(NextModal, {
  variants: {
    size: {
      auto: {
        wrapper: "max-w-[400px] w-full",
      },
    },
  },
});

interface IModalProps extends Omit<ModalProps, "children"> {
  children: ReactNode;
  isFullscreen?: boolean;
  closeColor?: TColor;
}

const Modal = React.forwardRef<
  React.ElementRef<typeof CustomModal>,
  IModalProps
>(({ children, isFullscreen, closeColor, ...props }, ref) => {
  useEffect(() => {
    if (!window.visualViewport) return;
    const setH = () =>
      document.documentElement.style.setProperty(
        "--visual-viewport-height",
        `${window.visualViewport!.height}px`,
      );
    setH();
    window.visualViewport.addEventListener("resize", setH);
    return () => window.visualViewport?.removeEventListener("resize", setH);
  }, []);

  return (
    <CustomModal
      {...props}
      ref={ref}
      hideCloseButton
      scrollBehavior="inside"
      size={isFullscreen ? "full" : "5xl"}
      placement={isFullscreen ? "top" : "center"}
      classNames={{
        backdrop: "z-[9999]",
        wrapper: "z-[10000]",

        ...props.classNames,
      }}

      // classNames={{
      //   ...props.classNames,
      //   closeButton: cn("text-red-500", props.classNames?.closeButton, closeColor ),
      // }}
    >
      <ModalContent>
        {/* {(onClose) => (
            <>
              <CloseButton
                size={27}
                color={closeColor}
                className={'absolute top-8 right-6 z-10'}
                onClick={onClose}
              />
            </>
          )} */}
        {children}
      </ModalContent>
    </CustomModal>
  );
});
Modal.displayName = "Modal";

export { Modal, ModalContent };
